import { Box, Fab, FabProps, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { memo } from 'react';

const FabSx: FabProps['sx'] = ({ palette }) => ({
    backgroundColor: palette.primary.main,
    '&:hover': {
        backgroundColor: palette.primary.dark,
    },
});

interface Props extends FabProps {
    onClick?: () => void;
    toolTip: React.ReactNode;
    containerStyle?: React.CSSProperties;
}

const FAB = ({ children, onClick, toolTip, containerStyle, ...rest }: Props) => {
    return (
        <Box sx={{ position: 'absolute', zIndex: 100, bottom: 100, right: 28, ...containerStyle }}>
            <Tooltip placement="left-end" title={toolTip}>
                <span>
                    <Fab onClick={onClick} sx={FabSx} {...rest}>
                        {children || <AddIcon sx={{ color: 'white' }} />}
                    </Fab>
                </span>
            </Tooltip>
        </Box>
    );
};

export default memo(FAB);
